// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2536175","wrapperXxs":"_ae5f2ef","message":"_1998e9b","wrapperXs":"_bad395b","wrapperSm":"_e91b02e","wrapperMd":"_f41fc65","wrapperLg":"_fd04615"};